import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../images/logo.png';

import {
  faCalendar,
  faUsers,
  faChartBar,
  faUserCircle,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import './SideMenu.css';

const SideMenu = ({ isOpen, onClose }) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const isAdmin = user.role === 'admin';

  const location = useLocation();

  return (
    <div className={`sidebar ${isOpen ? '' : 'hidden'}`}>
      <button className="close-sidebar" onClick={onClose}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <div className="sidebar-logo">
        <img src={logo} alt="Logo CCJAB" />
        <h2>CCJAB</h2>
      </div>

      <ul>
        <li className={location.pathname === '/' ? 'active' : ''}>
          <Link to="/" onClick={onClose}>
            <FontAwesomeIcon icon={faCalendar} className="icon" />
            <span>Calendrier</span>
          </Link>
        </li>

        {isAdmin && (
          <li className={location.pathname === '/membres' ? 'active' : ''}>
            <Link to="/membres" onClick={onClose}>
              <FontAwesomeIcon icon={faUsers} className="icon" />
              <span>Membres</span>
            </Link>
          </li>
        )}


        <li className={location.pathname === '/statistiques' ? 'active' : ''}>
          <Link to="/statistiques" onClick={onClose}>
            <FontAwesomeIcon icon={faChartBar} className="icon" />
            <span>Statistiques</span>
          </Link>
        </li>

        <li className={location.pathname === '/profil' ? 'active' : ''}>
          <Link to="/profil" onClick={onClose}>
            <FontAwesomeIcon icon={faUserCircle} className="icon" />
            <span>Mon profil</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SideMenu;